export default __webpack_public_path__ + "static/tab2Img-51103218c499f2921c6856cc0713805b.png";